"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceImage = void 0;

var react_1 = __importDefault(require("react"));

var thumb_svg_1 = __importDefault(require("./thumb.svg"));

var image_vertical_icon_svg_1 = __importDefault(require("./image-vertical-icon.svg"));

var prop_types_1 = __importDefault(require("prop-types"));

function ServiceImage(_ref) {
  var title = _ref.title,
      img = _ref.img,
      imgIcon = _ref.imgIcon,
      content = _ref.content,
      btnText = _ref.btnText,
      classNames = _ref.classNames;
  return react_1.default.createElement("div", {
    className: "relative cursor-pointer w-335px h-335px 2xl:w-367px 2xl:h-367px  ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.wrapper)
  }, react_1.default.createElement("div", {
    className: "absolute inset-0 bg-cover bg-center z-0  w-335px h-335px 2xl:w-367px 2xl:h-367px ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.imgWrapper),
    style: {
      backgroundImage: "url(".concat(img || thumb_svg_1.default, ")")
    }
  }), react_1.default.createElement("div", {
    className: "opacity-0 hover:opacity-100 bg-opacity-0 hover:bg-opacity-90 duration-300 absolute inset-0 z-10\n    justify-center items-center bg-gray-800 text-white text-center px-10 ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.contentWrapper)
  }, react_1.default.createElement("div", {
    className: "service-image-content-wrapper"
  }, react_1.default.createElement("div", {
    className: "service-image-icon  ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.imgIcon)
  }, imgIcon || react_1.default.createElement("img", {
    className: "mx-auto",
    src: image_vertical_icon_svg_1.default
  })), react_1.default.createElement("div", {
    className: "service-image-title block font-semibold  ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.title)
  }, title || 'Title'), react_1.default.createElement("div", {
    className: "service-image-content block text-sm font-normal mt-2px font-light  ".concat(classNames === null || classNames === void 0 ? void 0 : classNames.content)
  }, content || 'Content'))));
}

exports.ServiceImage = ServiceImage;
ServiceImage.propTypes = {
  title: prop_types_1.default.string,
  img: prop_types_1.default.string,
  imgIcon: prop_types_1.default.string,
  content: prop_types_1.default.string,
  btnText: prop_types_1.default.string,
  classNames: prop_types_1.default.object
};
ServiceImage.defaultProps = {
  title: 'Lorem Ipsum',
  content: 'Lorem Ipsum',
  btnText: 'CTA Action'
};